import React, { useState, useContext } from "react";
import {
    SettingsActionButton,
    SettingsBodyText,
    SettingsDangerActionButton,
    SettingsInfoBox,
    SettingsPanelCaption,
    SettingsPanelHeader,
    SettingsPanelStack,
    SettingsPanelTitle,
    SettingsSectionBody,
    SettingsSectionCard,
    SettingsSectionHeader,
    SettingsSectionIcon,
    SettingsSectionTitle,
} from "src/components";
import DataPrivacyIcon from "../../../img/subscription/download.svg";
import DataExportIcon from "../../../img/subscription/export-icon.svg";
import AccountDeletioModal from "../components/AccountDeletioModal";
import AccountDataRequestModal from "../components/AccountDataRequestModal";
import { SettingContext } from "../SettingContext";

const AccountCard = ({ title, icon, children }) => (
    <SettingsSectionCard>
        <SettingsSectionHeader>
            {icon && <SettingsSectionIcon src={icon} alt="" />}
            <SettingsSectionTitle>{title}</SettingsSectionTitle>
        </SettingsSectionHeader>
        <SettingsSectionBody>{children}</SettingsSectionBody>
    </SettingsSectionCard>
);

function PrivacyAndData() {
    const { token, isAccountOwner } = useContext(SettingContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [type, setType] = useState("employee");

    const pageHeadline = () => (
        <SettingsPanelHeader withDivider>
            <div>
                <SettingsPanelTitle>Privacy & Data</SettingsPanelTitle>
                <SettingsPanelCaption>
                Manage your data export and deletion requests. Account Owners have additional access to export company-level data.
                </SettingsPanelCaption>
            </div>
        </SettingsPanelHeader>
    );

    const handleRequestExport = (type) => {
        setType(type);
        setShowExportModal(true);
    };

    const handleDeleteAccount = (type) => {
        setType(type);
        setShowDeleteModal(true);
    };

    return (
        <>
            <SettingsPanelStack>
                {pageHeadline()}

                {/* Company Data Export (only for Account Owner) */}
                {isAccountOwner ? (
                    <AccountCard title="Request Company Data Export" icon={DataExportIcon}>
                        <SettingsInfoBox>
                            <SettingsBodyText>
                                Download a copy of your company data in a machine-readable CSV format.
                                This includes company records, activity records, and data you have entered into the platform, as well as your personal data.
                            </SettingsBodyText>

                            <SettingsActionButton
                                onClick={() => handleRequestExport("account_owner")}
                            >
                                Request Company & Personal Data Export
                            </SettingsActionButton>
                        </SettingsInfoBox>
                    </AccountCard>
                ) : (
                    <AccountCard title="Request Personal Data Export" icon={DataExportIcon}>
                        <SettingsInfoBox>
                            <SettingsBodyText>
                                Download a copy of your personal data stored by Me Business in a machine-readable CSV format. This includes
                                account details, activity records, and information you have entered into the platform.
                            </SettingsBodyText>

                            <SettingsActionButton
                                onClick={() => handleRequestExport("employee")}
                                minWidth="12rem"
                            >
                            Request Data Export
                            </SettingsActionButton>
                        </SettingsInfoBox>
                    </AccountCard>
                )}
                <AccountCard title="Delete Account & Data" icon={DataPrivacyIcon}>
                    <SettingsInfoBox background="#FFF5F5" border="#F3B5B5">
                        <SettingsBodyText color="#FF3B3B">
                            <strong>Warning:</strong>{" "}
                            <span style={{ fontStyle: "italic" }}>
                                This action is permanent. All account data, user information, and subscriptions{" "}
                                will be permanently deleted and cannot be recovered.
                            </span>
                        </SettingsBodyText>
                        <SettingsDangerActionButton onClick={() => handleDeleteAccount(isAccountOwner ? "account_owner" : "employee")}>
                            Delete Account & Data
                        </SettingsDangerActionButton>
                    </SettingsInfoBox>
                </AccountCard>
            </SettingsPanelStack>

            {/* Export Modal */}
            <AccountDataRequestModal
                token={token}
                open={showExportModal}
                handleClose={() => setShowExportModal(false)}
                exportType={type}
            />

            {/* Delete Modal */}
            <AccountDeletioModal
                token={token}
                open={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                deletionType={type}
            />
        </>
    );
}

export default PrivacyAndData;
